import _ from 'lodash'
import scroll from '../support/scroll'

export default {
    data () {
        return {
            page: _.toNumber(this.$route.query.page || 1),
            archived: _.toBoolean(this.$route.query.archived)
        }
    },
    watch: {
        page () {
            this.$router.replace({
                query: _.extend({}, this.$route.query, {
                    page: this.page
                })
            })

            scroll.toTop()
        },
        archived () {
            this.$router.replace({
                query: _.extend({}, this.$route.query, {
                    page: 1,
                    archived: this.archived ? 1 : 0
                })
            })

            scroll.toTop()
        },
        '$route' () {
            this.page = _.toNumber(this.$route.query.page || 1)
            this.archived = _.toBoolean(this.$route.query.archived)
        }
    }
}
